import { render, staticRenderFns } from "./MonthlyBillingCardSetup.vue?vue&type=template&id=97c8631c&scoped=true"
import script from "./MonthlyBillingCardSetup.vue?vue&type=script&lang=js"
export * from "./MonthlyBillingCardSetup.vue?vue&type=script&lang=js"
import style0 from "./MonthlyBillingCardSetup.vue?vue&type=style&index=0&id=97c8631c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c8631c",
  null
  
)

export default component.exports